import { Suspense } from "react";
import { useRoutes } from "react-router-dom";
// components
import { LoadingScreen } from "src/components/loading-screen";
//
import { authRoutes } from "./auth";
import { dashboardRoutes } from "./dashboard";
import { otherRoutes } from "./other";

// ----------------------------------------------------------------------

export default function Router() {
    return (
        <Suspense
            fallback={
                <LoadingScreen />
            }
        >
            {
                useRoutes([
                    // Auth routes
                    ...authRoutes,

                    // Dashboard routes
                    ...dashboardRoutes,

                    // Other routes
                    ...otherRoutes
                ])
            }
        </Suspense>
    );
}
